import { atom, useAtom, useAtomValue } from "jotai";
import { atomWithStorage } from "jotai/utils";

import { tickSizesByMarket } from "#/config/tickSizesByMarket";
import { marketAtom } from "#/store/app/portfolio/market";

export const tickSizeIndexAtom = atomWithStorage<number>("tickSizeIndex", 3);

export const tickSizesAtom = atom((get) => {
  const market = get(marketAtom);

  return tickSizesByMarket[market.underlying];
});

export const tickSizeAtom = atom((get) => {
  const tickSizes = get(tickSizesAtom);
  const tickSizeIndex = get(tickSizeIndexAtom);

  return tickSizes[tickSizeIndex];
});

export const useTickSize = () => {
  const [tickSizeIndex, setTickSizeIndex] = useAtom(tickSizeIndexAtom);
  const tickSize = useAtomValue(tickSizeAtom);
  const tickSizes = useAtomValue(tickSizesAtom);

  return {
    tickSize,
    tickSizes,
    tickSizeIndex,
    setTickSizeIndex,
  };
};
